export const SectionHeaderSkeleton = () => (
  <div className='flex items-center gap-3 mb-4'>
    <div className='h-10 w-10 bg-tertiary rounded-lg' />
    <div className='h-6 w-32 bg-tertiary rounded-sm' />
  </div>
);
